import { render, staticRenderFns } from "./MenuCollection.vue?vue&type=template&id=27c54346"
import script from "./MenuCollection.vue?vue&type=script&lang=js"
export * from "./MenuCollection.vue?vue&type=script&lang=js"
import style0 from "./MenuCollection.vue?vue&type=style&index=0&id=27c54346&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports